import React from 'react';
import { Field } from '../../Api/interfaces';
import './styles.css';

interface Props {
  field: Field;
  onTypeClicked?: (type: string) => void;
}

export default class FieldType extends React.Component<Props> {
  private selectByType(type: string): void {
    if (this.props.onTypeClicked) {
      this.props.onTypeClicked(type);
    }
  }

  private renderReferencedEntities(references: string[]): JSX.Element[] {
    return references.map((r) => (
      <li
        key={`li_${r}`}
        className="referencedEntity"
        onClick={() => this.selectByType(r)}
      >
        {r}
      </li>
    ));
  }

  render(): JSX.Element {
    const { field } = this.props;
    return (
      <div>
        {field.type}
        {field.referencedEntities && field.referencedEntities.length > 0 ? (
          <div className="referencedEntities">
            <span>Referenced Entities</span>
            <ul>{this.renderReferencedEntities(field.referencedEntities)}</ul>
          </div>
        ) : null}
      </div>
    );
  }
}
